module.exports = __webpack_public_path__ + "img/showbill2.ae13baeb.jpg";